<template>
  <div v-if="step === activeStep">
    <slot />
  </div>
</template>

<script>
// @vuese
// Sekcje kroków formularzy
// @group MaterialStepper
export default {
  props: {
    // Aktualny krok
    activeStep: { type: Number, required: true },
    // Krok danej sekcji
    step: { type: Number, required: true }
  }
};
</script>
